import "./index.scss";
import { IconButton } from "../../shared";
import {
    Box,
    ButtonGroup,
    Divider,
    Typography,
    useColorScheme,
    Button,
    IconButton as JoyIconButton,
    Input,
    Card,
    CardContent,
} from "@mui/joy";
import { Bell, ChevronDown, Menu, Moon, Plus, PlusCircle, Search, Settings, Sun, User } from "lucide-react";

import { useAuth } from "../../hooks";
import { Gate } from "../../shared";
import { PERMISSIONS } from "../../constants/permissions";
import { UserQuickNavigation } from "../../components";
import { Link } from "react-router-dom";

interface HeaderProps {
    onToggleCollapse?: () => void;
    isCollapsed?: boolean;
}

export default function Header({ onToggleCollapse, isCollapsed }: HeaderProps) {
    const { mode, setMode } = useColorScheme();
    const { user } = useAuth();

    return (
        <header>
            <Box className={"main-header"}>
                <IconButton variant="plain" color="neutral" onClick={onToggleCollapse} sx={{ mr: 1, ml: -1 }}>
                    <Menu size={20} />
                </IconButton>

                <Box sx={{ flex: 1, display: "flex", justifyContent: { xs: "flex-start" } }}>
                    <IconButton sx={{ display: { xs: "flex", sm: "none" } }} variant="plain" color={"neutral"}>
                        <Search size={20} />
                    </IconButton>
                    <Input
                        startDecorator={<Search size={18} />}
                        endDecorator={<CustomEndDecorator />}
                        variant="soft"
                        sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            display: { xs: "none", sm: "flex" },
                            width: "100%",
                            maxWidth: "400px",
                        }}
                        placeholder="Search or type a command"
                    />
                </Box>
                <Box sx={{ mx: 1 }}>
                    <Gate anyOf={[PERMISSIONS.PROJECT_CREATE]}>
                        <ButtonGroup
                            aria-label="new project button"
                            variant="solid"
                            color="primary"
                            sx={{ display: { xs: "none", sm: "flex" } }}
                        >
                            <Button startDecorator={<Plus size={18} />} component={Link} to="/project/new-v2">
                                New Project
                            </Button>
                            <JoyIconButton>
                                <ChevronDown size={18} />
                            </JoyIconButton>
                        </ButtonGroup>
                    </Gate>
                </Box>
                <Box className={"main-header-action-items flex align-items-center"}>
                    <Gate anyOf={[PERMISSIONS.ADMIN_SETTINGS]}>
                        <Link to="/admin/manufacture/">
                            <IconButton>
                                <Settings size={18} />
                            </IconButton>
                        </Link>
                    </Gate>

                    <IconButton onClick={() => setMode(mode === "light" ? "dark" : "light")}>
                        {mode === "light" ? <Sun size={18} /> : <Moon size={18} />}
                    </IconButton>
                    <IconButton>
                        <Bell size={18} />
                    </IconButton>
                    <Divider orientation="vertical" />
                    <UserQuickNavigation />
                </Box>
            </Box>
            <Divider />
        </header>
    );
}

function CustomEndDecorator() {
    return (
        <Card sx={{ p: 0.2, borderRadius: "6px", px: 1 }}>
            <CardContent>
                <Typography level="body-xs" sx={{ fontWeight: 500, color: "text.primary" }}>
                    ⌘ + K
                </Typography>
            </CardContent>
        </Card>
    );
}
